<template>
 
  <div>
    <label  for="categoria"><strong>CATEGORIA</strong></label>
    <v-select 
    :clearable="false" 
    :loading="loading" 
     :disabled="disabled"
    @input="setData"  :options="options" v-model="selected" :reduce="category => category.categoryId" label="category">
  
    <template #search="{attributes, events}" >
    <input
     
      class="vs__search"
      :required="!selected"
      v-bind="attributes"
      v-on="events"
    />
    </template>
    <template #option="{ category, group }">
      <h4 style="margin: 0">{{ category }}</h4>
      <em> 
        <!--        <i style="color:brown_" 
        :class="activeClass[group.index]"
        class="mr-2" aria-hidden="true"></i>
        -->  
        {{ group.name }} </em>
    </template>

    <template #selected-option="{ category, group}">
      <div style="display: flex; align-items: baseline">
        <strong>{{ category }}</strong>
        <em  style="margin-left: 0.5rem;" 
          > {{ group.name }} </em
        >
      </div>
    </template>
    <!--
    <template #spinner="{ loading }">
      <div
        v-if="loading"
        style="border-left-color: rgba(88, 151, 251, 0.71)"
        class="vs__spinner"
      >
        The .vs__spinner class will hide the text for me.
      </div>
    </template>
-->
    </v-select>
    

    
  </div>
</template>


<script>
//import {setCategory,sortCat} from '@/functions'; 

import api     from "@/api";
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import {mapGetters }   from 'vuex';


export default {
props: ['props','disabled'],
components: { vSelect },
data() {
    return {

        
        selected : null,
        options  : [],
        loading  : false,

        activeClass    : ['fas fa-user-tie','fas fa-ribbon','fas fa-suitcase','fas fa-shoe-prints']

    
        
    };
  },
computed: {
  ...mapGetters(['company']) 
  },
mounted: function () {

  this.getData()
},
  
methods: {
  setData(categoryId)
  {
    this.$emit("input", categoryId);
  },
  async getData()
    {            
      
      this.loading = true  
      let sp    = {'sp'        : 'spCategory_vSelect'}
      let data  = {'companyId' : this.company.Id}
      let json  = Object.assign(data, sp);  

      await api.post(json).then(res => {
            if(res.status==200)
            {
                let options = res.data.recordsets[0]
                let obj     = ''
                let index   = 0
                options.forEach(item =>{
                  index = 0  
                  if(item.Sort == 'ABBIGLIAMENTO')
                  {
                    index = 0
                  }  
                  if(item.Sort == 'ACCESSORI')
                  {
                    index = 1
                  }
                  if(item.Sort == 'BORSE')
                  {
                    index = 2
                  }
                  if(item.Sort == 'SCARPE')
                  {
                    index = 3

                    
                  }
                  obj = {'categoryId':item.categoryId,'category':item.category,
                    'group' : {'name' : item.Sort,'index':index }
                    
                  }
                  this.options.push(obj)
                }
                
                )
                
                this.selected = this.props.Id

                      
            }
           else if(res.status==500)
           {
                console.log(res.data)

            } 
          else
            {
                console.log('Network Error.')                  
                 
            } 
      
      

          }).catch(err => {
              
              console.log(err.message)    

              
          }).finally(() => {
            this.loading = false
        });

    

    },
  

}
}
</script>

<style scoped >
h4 {
  font-family: 'Roboto Condensed';
  /*font-size: 16px;*/
}

</style>
